// src/components/common/LoadingOverlay.js
// 44차: 앱 전체 통일 로딩 UI
// 사용법:
//   <LoadingOverlay />                     — 전체 화면 오버레이 (기본)
//   <LoadingOverlay inline />              — 인라인 중앙 스피너
//   <LoadingOverlay label="불러오는 중…" /> — 라벨 포함
//   <LoadingOverlay overlay />             — 반투명 오버레이 (기존 화면 위에 덮기)
// 51차: 색 theme.js 단일화 — COLORS 참조

import React, { useEffect, useRef } from 'react';
import { View, Text, ActivityIndicator, StyleSheet, Animated } from 'react-native';
import { COLORS } from '../../constants/theme';

const GOLD   = COLORS.gold;
const BG     = COLORS.bg;
const TEXT_MUTED = 'rgba(255,255,255,0.45)';

export default function LoadingOverlay({ label, inline = false, overlay = false }) {
  const fadeAnim = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    Animated.timing(fadeAnim, {
      toValue: 1,
      duration: 200,
      useNativeDriver: true,
    }).start();
  }, []);

  if (inline) {
    return (
      <Animated.View style={[s.inline, { opacity: fadeAnim }]}>
        <ActivityIndicator size="small" color={GOLD} />
        {label ? <Text style={s.label}>{label}</Text> : null}
      </Animated.View>
    );
  }

  if (overlay) {
    return (
      <Animated.View style={[s.overlayWrap, { opacity: fadeAnim }]}>
        <View style={s.overlayBox}>
          <ActivityIndicator size="large" color={GOLD} />
          {label ? <Text style={s.label}>{label}</Text> : null}
        </View>
      </Animated.View>
    );
  }

  return (
    <Animated.View style={[s.full, { opacity: fadeAnim }]}>
      <ActivityIndicator size="large" color={GOLD} />
      {label ? <Text style={s.label}>{label}</Text> : null}
    </Animated.View>
  );
}

const s = StyleSheet.create({
  full: {
    flex: 1,
    backgroundColor: BG,
    justifyContent: 'center',
    alignItems: 'center',
    gap: 14,
  },
  inline: {
    paddingVertical: 32,
    justifyContent: 'center',
    alignItems: 'center',
    gap: 10,
  },
  overlayWrap: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: 'rgba(10,10,20,0.72)',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 999,
  },
  overlayBox: {
    backgroundColor: COLORS.surface,
    borderRadius: 16,
    padding: 28,
    alignItems: 'center',
    gap: 14,
    borderWidth: 1,
    borderColor: 'rgba(212,168,67,0.18)',
  },
  label: {
    color: TEXT_MUTED,
    fontSize: 13,
    fontWeight: '500',
  },
});